// extracted by mini-css-extract-plugin
export default {"container":"fO-z","title":"gO-z","link":"hO-z"};